module.exports = __webpack_public_path__ + "img/attendance-reports.7eaf1b6e.png";